/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/adm-notification'

export default {
    get: params => {
        let customRoute = `${route}?expand=user,notificationGestor,status_description,status_lectura&search=${params.filter}`
        switch (params.notificacionEstado) {
            case "2": customRoute = `${route}?estado=1&expand=user,notificationGestor,status_description,status_lectura&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&expand=user,notificationGestor,status_description,status_lectura&search=${params.filter}`
                break;
            case "6": customRoute = `${route}?${params.customfilter}&expand=user,notificationGestor,status_description,status_lectura&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    getAllRecords: () => Api().get(`${route}?fields=id,nombre&expand=user,notificationGestor,status_description,status_lectura`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=user,notificationGestor,status_description,status_lectura`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=user,notificationGestor,status_description,status_lectura`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=user,notificationGestor,status_description,status_lectura`)
}
